import { render, staticRenderFns } from "./ContentImage.vue?vue&type=template&id=49b089d4"
import script from "./ContentImage.vue?vue&type=script&lang=js"
export * from "./ContentImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports